import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncFormHome({ ...rest }) {
  const AsyncLoad = loadable(() => import("../FormHome"));
  console.log("Loading", AsyncFormHome.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncFormHome;
